import { useMutation, type MutateOptions } from "@tanstack/react-query";
import { authService } from "../authService";

/**
 * Solicita o envio do código de recuperação de senha por WhatsApp. Usado tanto
 * na tela inicial de "Esqueci minha senha" quanto no botão "Reenviar código".
 */
export const useForgotPassword = () => {
  const {
    mutate: sendPhone,
    variables,
    isPending,
  } = useMutation<void, Error, { phone: string } | undefined>({
    mutationFn: variables => {
      if (!variables) {
        throw new Error("Telefone é obrigatório");
      }

      return authService.handleForgotPassword(variables.phone);
    },
  });

  const resendPhone = (
    options?: MutateOptions<void, Error, { phone: string } | undefined>
  ) => {
    sendPhone(variables, options);
  };

  return {
    sendPhone,
    resendPhone,
    isPending,
  };
};
